import clsx from 'clsx';
import Button from '../Button/Button';
import {
  ButtonAlign,
  ButtonColor,
  ButtonSize,
  ButtonType,
  ShowAddon,
  ShowIcon,
} from '../Button/consts';
import { ClickableAction } from '../Clickable/consts';
import type { IconVariants } from '../Icon/interfaces';
import StageBox from '../StageBox/StageBox';
import styles from './StageBoxFormBase.module.scss';
import type { StageBoxFormBaseProps } from './types';

const StageBoxFormBase = ({
  title,
  titleTag: TitleTag = 'h1',
  children,
  backgroundType = 'gradient',
  ...props
}: StageBoxFormBaseProps) => {
  return (
    <StageBox backgroundType={backgroundType}>
      <div className={clsx(styles.stageBox, styles[backgroundType])}>
        <TitleTag className={styles.title}>{title}</TitleTag>
        <div className={styles.form}>{children}</div>
        {'buttonSlot' in props ? (
          props.buttonSlot
        ) : (
          <SubmitButton
            buttonIcon={props.buttonIcon}
            backgroundType={backgroundType}
          >
            {props.buttonText}
          </SubmitButton>
        )}
      </div>
    </StageBox>
  );
};

const SubmitButton = ({
  children,
  buttonIcon,
  backgroundType,
}: {
  children: React.ReactNode;
  buttonIcon?: IconVariants;
  backgroundType: 'gradient' | 'white';
}) => (
  <Button
    className={styles.submitButton}
    type={ButtonType.Submit}
    actionType={ClickableAction.None}
    align={ButtonAlign.Left}
    color={
      backgroundType === 'gradient'
        ? ButtonColor.Secondary
        : ButtonColor.Primary
    }
    showAddon={ShowAddon.Gradient}
    showIcon={ShowIcon.ShowIcon}
    icon={buttonIcon}
    size={ButtonSize.Large}
    noClickable
  >
    {children}
  </Button>
);

StageBoxFormBase.SubmitButton = SubmitButton;

export default StageBoxFormBase;
